// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("location", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        filter : {
          'name':params.search
        }
      })
        .then(({ data }) => {
          context.commit("set_locations", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          reject(response)
        });
    });
  },
  list(context, params) {
    const {search, id} = params ?? [null,null]
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("location", {
        filter : {
          'name':search,
          'id':id
        }
      })
        .then(({ data }) => {
          context.commit("set_locations", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          console.log("louper");
        });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("location", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          reject(response);
        })
        .finally(()=>{
          context.commit("unset_loading");
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("location/" + params.model.id, params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
          context.commit("set_error", response.data.errors);
        })
        .finally(()=>{
          context.commit("unset_loading");
        });
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject)=> {
      NewApiService.delete("location/" + params.model.id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          reject(response);
        })
        .finally(()=>{
          context.commit("unset_loading");
        });
    });
  }
};
